// Simple in-memory (localStorage-backed) store for the school comparison list.
const KEY = "tsr_compare_ids";
const MAX = 3;

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
};
const write = (arr) => localStorage.setItem(KEY, JSON.stringify(arr));

export const compareStore = {
  get: () => read(),
  has: (id) => read().includes(id),
  count: () => read().length,
  MAX,
  add: (id) => {
    const cur = read();
    if (cur.includes(id)) return { ok: false, reason: "already" };
    if (cur.length >= MAX) return { ok: false, reason: "full" };
    const next = [...cur, id];
    write(next);
    window.dispatchEvent(new Event("compare:changed"));
    return { ok: true, list: next };
  },
  remove: (id) => {
    const next = read().filter((x) => x !== id);
    write(next);
    window.dispatchEvent(new Event("compare:changed"));
    return next;
  },
  clear: () => {
    write([]);
    window.dispatchEvent(new Event("compare:changed"));
  },
};

// React hook for subscribing to changes.
import { useEffect, useState } from "react";
export function useCompareIds() {
  const [ids, setIds] = useState(compareStore.get());
  useEffect(() => {
    const h = () => setIds(compareStore.get());
    window.addEventListener("compare:changed", h);
    window.addEventListener("storage", h);
    return () => {
      window.removeEventListener("compare:changed", h);
      window.removeEventListener("storage", h);
    };
  }, []);
  return ids;
}

// Format IDR
export function formatIDR(n) {
  if (n == null) return "—";
  if (n === 0) return "Gratis";
  if (n >= 1000000) return `Rp ${(n / 1000000).toFixed(n % 1000000 === 0 ? 0 : 1)} jt/bulan`;
  if (n >= 1000) return `Rp ${(n / 1000).toFixed(0)} rb/bulan`;
  return `Rp ${n}/bulan`;
}
